module.exports = __webpack_public_path__ + "img/p14.1ac576fa.png";